<a
  class="link"
  [class.link--small]="isChildItem() && !isExpanded()"
  matRipple
  [routerLink]="[path()]"
  [routerLinkActive]="'link--active'"
  [routerLinkActiveOptions]="{ exact: path() === '/' }"
  (click)="rla.isActive || emitItemClick()"
  #rla="routerLinkActive"
  #link
>
  <mat-icon class="link__icon" [class]="rla.isActive ? '' : 'material-icons-outlined'">
    {{ icon() }}
  </mat-icon>

  <div class="link__label truncate">{{ label() }}</div>

  @if (isParentItem() && isExpanded()) {
    <mat-icon class="link__chevron" [class.link__chevron--open]="rla.isActive">expand_more</mat-icon>
  }
</a>
